const toDateInputValue = date => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const defaultDashboardDateRange = () => {
  const today = new Date();
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);
  return {
    createdFrom: toDateInputValue(sevenDaysAgo),
    createdTo: toDateInputValue(today),
  };
};

export const DEFAULT_DASHBOARD_FILTERS = () => ({
  pipelineId: null,
  status: 'open',
  ownerId: null,
  inboxId: null,
  ...defaultDashboardDateRange(),
});

export const formatCurrencyValue = (value, currency = 'BRL') =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));

export const buildOpportunityDashboardParams = ({
  pipelineId,
  status,
  ownerId,
  inboxId,
  createdFrom,
  createdTo,
} = {}) => ({
  pipeline_id: pipelineId,
  status: status || undefined,
  owner_id: ownerId || undefined,
  inbox_id: inboxId || undefined,
  created_from: createdFrom || undefined,
  created_to: createdTo || undefined,
});
